import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Tab, AppBar, Grid, Badge, Tabs, Typography, Box, Zoom } from "@material-ui/core";
import PropTypes from "prop-types";
import ContactsOutlinedIcon from "@material-ui/icons/ContactsOutlined";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import { PanelDatos } from './PanelDatos'
import { useDispatch, useSelector } from "react-redux";
import { fetchObservaciones } from "../../actions/preAfiliado/observaciones";
import { ObservacionItemPreafiliado } from "../preafiliaciones/ObservacionItemPreafiliado";
import { fetchDocumentacionStageAfiliacion } from "../../actions/documentaciones/documentacion";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    padding: 10,
    marginTop: 20
  }
}));
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-force-tab-${index}`,
    "aria-controls": `scrollable-force-tabpanel-${index}`,
  };
}

export const TabIngresoTitular = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { afiliadoEncontrado } = useSelector((state) => state.preinscripto);
  const { items } = useSelector((state) => state.observacionesPreafiliados);

  const [tab, setTab] = React.useState(0);

  const handleChange = (e, tabselec) => {
    if (tabselec === 1) {
      props.setMostrarNext(true)
    } else {
      props.setMostrarNext(false)
    }
    setTab(tabselec);
  };

  useEffect(() => {
    dispatch(fetchObservaciones())
    dispatch(fetchDocumentacionStageAfiliacion(afiliadoEncontrado.id_afiliado))
    // eslint-disable-next-line
  }, [dispatch])

  return (
    <div className={classes.root}>
      <AppBar position="static" color="default" style={{ width: "100%" }}>
        <Grid container direction="row" alignItems="center">
          <Tabs
            value={tab}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="on"
            indicatorColor="primary"
            textColor="primary"
            aria-label="scrollable"
          >
            <Tab
              label="Datos Personales"
              icon={
                <ContactsOutlinedIcon />}
              {...a11yProps(0)}
            />
            {afiliadoEncontrado?.estado > 10 && <Tab
              label="Observaciones"
              icon={
                <Badge
                  classes={{ badge: classes.customBadge }}
                  badgeContent={items.lenght > 0 ? items.lenght : 0}
                >
                  <DescriptionOutlinedIcon />
                </Badge>
              }
              {...a11yProps(1)}
            />}
          </Tabs>
        </Grid>
      </AppBar>
      <Zoom style={{ transitionDelay: "100ms" }} in={tab === 0}>
        <TabPanel value={tab} index={0}>
          <PanelDatos
            fromBandeja={props.fromBandeja}
            idTabIngreso={props.idTabIngreso}
            idPanel={"idTabIngreso"}
            fromBandejaFamiliar={props.fromBandejaFamiliar}
          />
        </TabPanel>
      </Zoom>
      <Zoom style={{ transitionDelay: "500ms" }} in={tab === 1}>
        <TabPanel value={tab} index={1}>
          {
            items.lenght === 0
              ?
              <Grid container item justify="center" style={{ margin: 30 }}><Typography variant="h4" component="h2">Sin Observaciones ...</Typography> </Grid>
              :
              items.map((item, index) => <ObservacionItemPreafiliado key={index} item={item} />)
          }
        </TabPanel>
      </Zoom>
    </div>
  );

};
